import { Outlet } from 'react-router-dom';

import { TCustomRouteObject } from '@/shared/types/router.types';

export const notificationsRoutes: TCustomRouteObject = {
  path: '/notifications',
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'notifications',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { NotificationsRoute } = await import('./notifications');
        return { Component: NotificationsRoute };
      },
    },
  ],
};
